exports = module.exports = require("../../../web-client/src/client/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "nr-compile {\n  box-sizing: border-box;\n  display: block;\n  margin: 0;\n  padding: 0; }\n", ""]);
